module.exports = __webpack_public_path__ + "img/11.3bdba950.jpg";